"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialTextFieldSmall = void 0;
const callable_1 = require("client/components/ui/callable");
const Form_1 = require("material-ui/Form");
const Input_1 = require("material-ui/Input");
const styles_1 = require("material-ui/styles");
const react_1 = require("react");
const React = require("react");
require("./text-field.less");
const decorate = styles_1.withStyles(theme => ({
    formControl: {
        background: "#fff",
        border: "solid 1px rgba(0, 0, 0, 0.1)",
        borderRadius: "2px",
        fontSize: "5px",
        minHeight: 40,
        minWidth: 120,
        padding: "0 10px"
    },
    formControlDisabled: {
        color: "#aaa"
    },
    formControlError: {
        border: "1px solid #d81b60"
    },
    helperText: {
        color: "#d81b60",
        position: "absolute",
        top: 50
    },
    inputLabel: {
        transform: "translate(0, 1px) scale(1)"
    },
    inputFocused: {
        border: "1px solid rgba(24, 194, 115, 0.5)"
    },
    inputLabelShrink: {
        transform: "translate(0, 1px) scale(0.8)"
    },
    inputRoot: {
        minHeight: 40,
        left: 0,
        padding: "15px 0 0 10px",
        position: "absolute",
        top: -16
    },
    root: {}
}));
class MaterialTextFieldSmallUnstyled extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleOnChange = (event) => {
            let { value } = event.target;
            if (value !== "") {
                if (this.props.type === "number" && this.props.numType === "integer") {
                    value = String(parseInt(value, 10));
                }
                if (this.props.numType === "decimal") {
                    value = value.replace(/[^0-9\.]/g, "");
                    value = String(parseFloat(value));
                }
                else if (this.props.numType === "price") {
                    value = value.replace(/[^0-9\.]/g, "");
                    let precision = value
                        .split(".")
                        .slice(1)
                        .join().length;
                    if (precision > 2) {
                        precision = 2;
                    }
                    if (precision > 0) {
                        value = String((Math.trunc(parseFloat(value) * 100) / 100).toFixed(precision));
                    }
                }
            }
            callable_1.callable(this.props.onChange)(event, value);
        };
        this.handleKeyDown = (event) => {
            if (this.props.type === "number" && this.props.numType === "integer") {
                if (event.key === ".") {
                    event.preventDefault();
                }
            }
            this.handleEnter(event);
        };
        this.handleKeyPress = (event) => {
            callable_1.callable(this.props.onKeyPress)(event);
        };
    }
    render() {
        const { className = "", classes, disabled, error, label, leftItem, multiline = false, helperText, required, rightItem, value, missing } = this.props;
        const hasIcon = leftItem ? "has-icon" : "";
        const hasError = error ? "material-text-field-small--error" : "";
        const isMissing = missing ? "material-text-field-small--missing" : "";
        return (React.createElement(Form_1.FormControl, { classes: {
                root: classes.formControl
            }, error: error, disabled: disabled, required: required, className: `material-text-field-small ${className} ${hasIcon} ${hasError} ${isMissing}` },
            leftItem && (React.createElement("div", { className: "material-text-field-small__icon" }, leftItem)),
            React.createElement(Input_1.InputLabel, { classes: {
                    root: classes.inputLabel,
                    shrink: classes.inputLabelShrink
                }, FormControlClasses: {
                    disabled: classes.formControlDisabled
                } }, label),
            React.createElement(Input_1.default, { autoFocus: this.props.autoFocus, onBlur: this.props.onBlur, inputRef: this.props.ref ? this.props.ref : null, classes: {
                    root: classes.inputRoot,
                    error: classes.formControlError,
                    focused: classes.inputFocused
                }, disableUnderline: true, fullWidth: true, multiline: multiline, onChange: this.handleOnChange, onKeyDown: this.handleKeyDown, onKeyPress: this.handleKeyPress, type: this.props.type || "text", value: value, placeholder: this.props.placeholder, inputProps: this.props.inputProps }),
            rightItem ? (React.createElement("div", { className: "material-text-field-small__right-item" }, rightItem)) : null,
            React.createElement(Form_1.FormHelperText, { classes: {
                    root: classes.helperText
                } }, helperText)));
    }
    handleEnter(event) {
        // console.log("handle enter triggered: **********");
        if (event.keyCode === 13 || event.keyCode === 9) {
            this.props.onKeyDownEnterPress();
            // C-097 Ayush comit below 3 line code
            // const form = event.target.form;
            // const index = Array.prototype.indexOf.call(form, event.target);
            // form.elements[index + 1].focus();
            event.preventDefault();
        }
    }
}
// class MaterialTextFieldUnstyledSortable extends Component<
//   IProps &
//     WithTheme &
//     WithStyles<
//       | 'formControl'
//       | 'formControlDisabled'
//       | 'formControlError'
//       | 'helperText'
//       | 'inputFocused'
//       | 'inputLabel'
//       | 'inputLabelShrink'
//       | 'inputRoot'
//       | 'root'
//     >
// > {
//   public render() {
//     const {
//       className = '',
//       classes,
//       disabled,
//       error,
//       label,
//       leftItem,
//       multiline = false,
//       helperText,
//       required,
//       rightItem,
//       value,
//       missing,
//     } = this.props;
//     const hasIcon = leftItem ? 'has-icon' : '';
//     const hasError = error ? 'material-text-field--error' : '';
//     const isMissing = missing ? 'material-text-field--missing' : '';
//     return (
//       <FormControl
//         classes={{
//           root: classes.formControl,
//         }}
//         error={error}
//         disabled={disabled}
//         required={required}
//         className={`material-text-field ${className} ${hasIcon} ${hasError} ${isMissing}`}
//       >
//         {leftItem && (
//           <div className="material-text-field__icon">{leftItem}</div>
//         )}
//         <InputLabel
//           classes={{
//             root: classes.inputLabel,
//             shrink: classes.inputLabelShrink,
//           }}
//           FormControlClasses={{
//             disabled: classes.formControlDisabled,
//           }}
//         >
//           {label}
//         </InputLabel>
//         <Input
//           autoFocus={this.props.autoFocus}
//           onBlur={this.props.onBlur} // #TK added onBlur to this.props
//           classes={{
//             root: classes.inputRoot,
//             error: classes.formControlError,
//             focused: classes.inputFocused,
//           }}
//           disableUnderline={true}
//           fullWidth={true}
//           multiline={multiline}
//           onChange={this.handleOnChange}
//           onKeyDown={this.handleKeyDown}
//           type={this.props.type || 'text'}
//           value={value}
//         />
//         {rightItem ? (
//           <div className="material-text-field__right-item">{rightItem}</div>
//         ) : null}
//         <FormHelperText
//           classes={{
//             root: classes.helperText,
//           }}
//         >
//           {helperText}
//         </FormHelperText>
//       </FormControl>
//     );
//   }
//   private handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
//     let { value } = event.target;
//     if (value !== '') {
//       if (this.props.type === 'number' && this.props.numType === 'integer') {
//         value = String(parseInt(value));
//       }
//       if (this.props.numType === 'decimal') {
//         value = value.replace(/[^0-9\.]/g, '');
//         value = String(parseFloat(value));
//       } else if (this.props.numType === 'price') {
//         value = value.replace(/[^0-9\.]/g, '');
//         let precision = value
//           .split('.')
//           .slice(1)
//           .join().length;
//         if (precision > 2) {
//           precision = 2;
//         }
//         if (precision > 0) {
//           value = String(
//             (Math.trunc(parseFloat(value) * 100) / 100).toFixed(precision),
//           );
//         }
//       }
//     }
//     callable(this.props.onChange)(event, value);
//   };
//   private handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
//     if (this.props.type === 'number' && this.props.numType === 'integer') {
//       if (event.key === '.') {
//         event.preventDefault();
//       }
//     }
//     if (event.key === 'Enter') {
//       this.props.onBlur(); // #TK unfocused
//     }
//   };
// }
// class MaterialTextFieldUnstyledGroupText extends Component<
//   IProps &
//     WithTheme &
//     WithStyles<
//       | 'formControl'
//       | 'formControlDisabled'
//       | 'formControlError'
//       | 'helperText'
//       | 'inputFocused'
//       | 'inputLabel'
//       | 'inputLabelShrink'
//       | 'inputRoot'
//       | 'root'
//     >
// > {
//   public render() {
//     const {
//       className = '',
//       classes,
//       disabled,
//       error,
//       label,
//       leftItem,
//       multiline = false,
//       helperText,
//       required,
//       rightItem,
//       value,
//       missing,
//     } = this.props;
//     const hasIcon = leftItem ? 'has-icon' : '';
//     const hasError = error ? 'material-text-field--error' : '';
//     const isMissing = missing ? 'material-text-field--missing' : '';
//     return (
//       <FormControl
//         classes={{
//           root: classes.formControl,
//         }}
//         error={error}
//         disabled={disabled}
//         required={required}
//         className={`material-text-field ${className} ${hasIcon} ${hasError} ${isMissing}`}
//       >
//         {leftItem && (
//           <div className="material-text-field__icon">{leftItem}</div>
//         )}
//         <InputLabel
//           classes={{
//             root: classes.inputLabel,
//             shrink: classes.inputLabelShrink,
//           }}
//           FormControlClasses={{
//             disabled: classes.formControlDisabled,
//           }}
//         >
//           {label}
//         </InputLabel>
//         <Input
//           autoFocus={this.props.autoFocus}
//           onBlur={this.props.onBlur} // #TK added onBlur to this.props
//           classes={{
//             root: classes.inputRoot,
//             error: classes.formControlError,
//             focused: classes.inputFocused,
//           }}
//           disableUnderline={true}
//           fullWidth={true}
//           multiline={multiline}
//           onChange={this.handleOnChange}
//           onKeyDown={this.handleKeyDown}
//           type={this.props.type || 'text'}
//           value={value}
//         />
//         {rightItem ? (
//           <div className="material-text-field__right-item">{rightItem}</div>
//         ) : null}
//         <FormHelperText
//           classes={{
//             root: classes.helperText,
//           }}
//         >
//           {helperText}
//         </FormHelperText>
//       </FormControl>
//     );
//   }
//   private handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
//     let { value } = event.target;
//     if (value !== '') {
//       if (this.props.type === 'number' && this.props.numType === 'integer') {
//         value = String(parseInt(value));
//       }
//       if (this.props.numType === 'decimal') {
//         value = value.replace(/[^0-9\.]/g, '');
//         value = String(parseFloat(value));
//       } else if (this.props.numType === 'price') {
//         value = value.replace(/[^0-9\.]/g, '');
//         let precision = value
//           .split('.')
//           .slice(1)
//           .join().length;
//         if (precision > 2) {
//           precision = 2;
//         }
//         if (precision > 0) {
//           value = String(
//             (Math.trunc(parseFloat(value) * 100) / 100).toFixed(precision),
//           );
//         }
//       }
//     }
//     callable(this.props.onChange)(event, value);
//   };
//   private handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
//     if (this.props.type === 'number' && this.props.numType === 'integer') {
//       if (event.key === '.') {
//         event.preventDefault();
//       }
//     }
//     if (event.key === 'Enter') {
//       this.props.onBlur(); // #TK unfocused
//       this.props.onAddGroup();
//     }
//   };
// }
exports.MaterialTextFieldSmall = styles_1.withTheme()(decorate(MaterialTextFieldSmallUnstyled));
// export const MaterialTextFieldSortable = withTheme()(
//   decorate(MaterialTextFieldUnstyledSortable),
// );
// export const MaterialTextFieldGroupText = withTheme()(
//   decorate(MaterialTextFieldUnstyledGroupText),
// );



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/text-field/text-field-small.tsx
// module id = 323
// module chunks = 0